module.exports = __webpack_public_path__ + "static/media/logo-color.7f017d00.svg";